import { blue } from "@ant-design/colors";
import { Card, Col, Row } from "antd";
import Nominator from "./Nominator";
import { useTranslation } from "react-i18next";

const Nominators = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[8, 16]}>
      {data?.map((item, index) => {
        return (
          <Col span={24}>
            <Card
              title={
                <span
                  style={{ color: blue.primary, textTransform: "uppercase" }}
                >
                  {item?.is_org === true
                    ? t("str_organization_info")
                    : t("str_nominator_info")}
                  #{index + 1}
                </span>
              }
            >
              <Nominator
                userInfo={item}
                disabled={true}
                isSecretariatView={false}
              />
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default Nominators;
